import React from 'react';
import type { BikeSafetyProfile } from '../types/api';

interface RouteSliderProps {
  maxTransfers: number;
  setMaxTransfers: (n: number) => void;
  bikeTransferWeight: number;
  setBikeTransferWeight: (n: number) => void;
  bikeSafety: BikeSafetyProfile;
  setBikeSafety: (p: BikeSafetyProfile) => void;
}

const SAFETY_LABELS: Record<BikeSafetyProfile, { label: string; desc: string }> = {
  normal: { label: 'Normal', desc: 'Fastest bike route' },
  calm: { label: 'Calm', desc: 'Prefers quiet streets' },
  safest: { label: 'Safest', desc: 'Max safety, may be longer' },
};

export default function RouteSliders({
  maxTransfers,
  setMaxTransfers,
  bikeTransferWeight,
  setBikeTransferWeight,
  bikeSafety,
  setBikeSafety,
}: RouteSliderProps) {
  return (
    <div className="route-sliders">
      <div className="slider-group">
        <label className="slider-label">
          Max transfers: <strong>{maxTransfers}</strong>
        </label>
        <input
          type="range"
          min={0}
          max={5}
          step={1}
          value={maxTransfers}
          onChange={(e) => setMaxTransfers(Number(e.target.value))}
          className="slider"
        />
        <div className="slider-ticks">
          <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
        </div>
      </div>
      <div className="slider-group">
        <label className="slider-label">
          Prefer bike over transfer: <strong>{bikeTransferWeight}/10</strong>
        </label>
        <input
          type="range"
          min={0}
          max={10}
          step={1}
          value={bikeTransferWeight}
          onChange={(e) => setBikeTransferWeight(Number(e.target.value))}
          className="slider"
        />
        <div className="slider-range-labels">
          <span>Allow transfers</span><span>Avoid transfers</span>
        </div>
      </div>
      <div className="slider-group">
        <label className="slider-label">Bike route safety</label>
        <div className="safety-btns">
          {(Object.entries(SAFETY_LABELS) as [BikeSafetyProfile, { label: string; desc: string }][]).map(([key, val]) => (
            <button
              key={key}
              className={`safety-btn ${bikeSafety === key ? 'active' : ''}`}
              onClick={() => setBikeSafety(key)}
              title={val.desc}
            >
              {val.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
